<form class="awair-form" [formGroup]="form" (ngSubmit)="login()">

  <div class="form-header">Log in to SGS AirSense Dashboard</div>
  <div class="form-sub-header">Enter your details below</div>

  <!-- Email -->
  <div class="input-header email-header">Email Address</div>
  <input type="email"
         class="email-input"
         name="email"
         formControlName="email"
         placeholder="sample@email.com"
         #emailView>
  <!-- /.Email -->

  <!-- Password -->
  <div class="input-header password-header">Password</div>
  <a class="input-header forgot-password"
     tabindex="-1"
     target="_blank"
     rel="noreferrer noopener"
     [attr.href]="forgotPasswordUrl">
    Forgot Password?
  </a>
  <input type="password"
         class="password-input"
         name="password"
         formControlName="password"
         placeholder="password">
  <!-- /.Password -->

  <!-- Error MSG -->
  <div class="error-msg"
       id="warning-msg"
       [class.show-error-msg]="isWarning">
    {{errorMessage}}
  </div>
  <!-- ./ Error MSG -->

  <button type="submit"
          class="aw-btn aw-btn-blue"
          [disabled]="!form.valid || isLoggingIn || isLoggedIn"
          [ngClass]="isLoggingIn ? 'login-button-pressed' : null">
    Log In
  </button>

  <p class="signup-guide">
    Don't have an account?
    <a routerLink='/signup'>Sign Up</a>
  </p>
</form>
